import React from "react";

export default function HeatMapBlock({ item, isSchool, themeTab }) {
  const list = item?.dimensions || [];

  function hexToRgbA(hex, opacity) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c & 255}, ${opacity})`;
    }
    return hex;
  }

  function getLightColor(bucket, isSchool) {
    const schoolColors = {
      Thinking: "#FFF0C4",
      Acting: "#CAE6FC",
      Learning: "#DBD0EE",
      Relating: "#D4ECD5",
      Emotions: "#FFE6C2",
      Communicating: "#C2EFF5",
    };

    const defaultColors = {
      "THINKING TALENTS": "#FFF0C4",
      "ACTING TALENTS": "#CAE6FC",
      "LEADING TALENTS": "#DBD0EE",
      "RELATING TALENTS": "#D4ECD5",
    };

    const map = isSchool ? schoolColors : defaultColors;
    return map[bucket] || "#F2F2F2";
  }

  return (
    <div>
      {list.map((element) => {

        let isTopFive = element.rank <= 5;
        if (themeTab === "Overall") {
          isTopFive = true;
        } else if (themeTab === "Top 5") {
          isTopFive = element.rank <= 5;
        } else if (themeTab === "Top 7") {
          isTopFive = element.rank <= 7;
        } else if (themeTab === "Top 10") {
          isTopFive = element.rank <= 10;
        }

        const bgColor = isTopFive
          ? hexToRgbA(item?.colorCode || "#DDDDDD", "1")
          : getLightColor(item.bucket, isSchool);

        const textcolor = isTopFive
          ? item.bucket?.trim() === "THINKING TALENTS"
            ? "#212121"
            : "#FFFFFF"
          : "#000000";

        return (
          <div key={element.rank} className="pl-6 pb-1">
            <div
              className="relative flex items-center py-3 font-medium text-lg pl-16 pr-12 w-full"
              style={{ background: (isTopFive ? bgColor : "#F1F5F9"), color: textcolor }}
            >
              <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center font-medium text-base border-4 border-white"
                  style={{ background: bgColor, color: textcolor }}
                >
                  {element.rank}
                </div>
              </div>

              {element.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}
